import React, { useEffect, useState, useRef, useCallback } from "react";
import ProductCard from "./ProductCard";

// Usa variable de entorno compatible con CRA
const ENDPOINT = process.env.REACT_APP_API_ENDPOINT || "https://s902oia0ti.execute-api.us-east-1.amazonaws.com/";

export default function ProductList() {
  const [products, setProducts] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [page, setPage] = useState(1);
  const [hasMore, setHasMore] = useState(true);

  const observer = useRef();

  // Callback para el último elemento
  const lastProductRef = useCallback(
    (node) => {
      if (loading) return;
      if (observer.current) observer.current.disconnect();
      observer.current = new window.IntersectionObserver((entries) => {
        if (entries[0].isIntersecting && hasMore) {
          setPage((prevPage) => prevPage + 1);
        }
      });
      if (node) observer.current.observe(node);
    },
    [loading, hasMore]
  );

  useEffect(() => {
    setLoading(true);
    setError(null);

    // Si es la primera página, limpiar productos antes de cargar
    if (page === 1) {
      setProducts([]);
    }

    fetch(`${ENDPOINT}?page=${page}`)
      .then((res) => {
        if (!res.ok) throw new Error("Error al cargar productos");
        return res.json();
      })
      .then((data) => {
        if (data && Array.isArray(data.perfumes)) {
          setProducts((prev) =>
            page === 1 ? data.perfumes : [...prev, ...data.perfumes]
          );
          setHasMore(data.has_next_page);
        } else {
          setHasMore(false);
        }
      })
      .catch((err) => setError(err.message))
      .finally(() => setLoading(false));
  }, [page]);

  return (
    <>
      <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
        {Array.isArray(products) && products.length > 0 ? (
          products.map((product, idx) => {
            if (idx === products.length - 1) {
              return (
                <div ref={lastProductRef} key={product.sku}>
                  <ProductCard product={product} />
                </div>
              );
            }
            return <ProductCard key={product.sku} product={product} />;
          })
        ) : (
          <div className="col-span-full text-center text-gray-500">
            No hay productos para mostrar.
          </div>
        )}
      </div>
      {loading && (
        <div className="text-center my-4">Cargando productos...</div>
      )}
      {error && (
        <div className="text-center text-red-500 my-4">Error: {error}</div>
      )}
      {!hasMore && !loading && products.length > 0 && (
        <div className="text-center text-gray-400 my-4">
          No hay más productos.
        </div>
      )}
    </>
  );
}